// extracted by mini-css-extract-plugin
export default {"grabby":"Grabby_grabby__kECnO","svg":"Grabby_svg__fAxCc","lefteye":"Grabby_lefteye__VU3OI","anim1":"Grabby_anim1__XhoTm","righteye":"Grabby_righteye__wppxN"};